
(function ($) {
    const defaultOptions = {
        validClass: 'is-valid',
        errorClass: 'is-invalid',
        highlight: function (element, errorClass, validClass) {
            $(element)
                .removeClass(validClass)
                .addClass(errorClass);

            $(element)
                .closest('.input-group')
                .removeClass(validClass)
                .addClass(errorClass);

            $(element)
                .closest('.input-group').next('select')
                .removeClass(validClass)
                .addClass(errorClass);
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element)
                .removeClass(errorClass)
                .addClass(validClass);

            $(element)
                .closest('.input-group')
                .removeClass(errorClass)
                .addClass(validClass);

            $(element)
                .closest('.input-group').next('select')
                .removeClass(errorClass)
                .addClass(validClass);
        },
        rules: window.options.validationRules,
        ignore: '.unobval-ignore'
    };

    $.validator.setDefaults(defaultOptions);

    $.validator.unobtrusive.options = {
        errorClass: defaultOptions.errorClass,
        validClass: defaultOptions.validClass
    };
})(jQuery);

window.recaptchaV2CheckboxCallback = function () {
    $('button[type="submit"]').prop('disabled', false);
}
